
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue'
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import contactInfo from "@/apps/shared/components/ContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import localityService from '@/apps/shared/services/locality-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'tabOne',
        components: {
            XBreadcrumb,
            contactInfo,
            TitleAndPromotions,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Accidentes Personales Íntegro Max",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos",
                    product: "AP Íntegro Max",
                    icon: {
                        src: "/logos/AP_Integro.svg",
                        alt: 'AP Íntegro Max',
                        title: 'AP Íntegro Max'
                    },
                    iconPromotion: {
                        src: '/icons/hotweek-logo.png',
                        alt: 'logoHotWeek',
                        title: 'HotWeek'
                    },
                    otherIconPromotion: {
                        src: '/icons/cybermonday.svg',
                        alt: 'logoCiberMonday',
                        title: 'CiberMonday'
                    },
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                name: '',
                lastName: '',
                telephone: '',
                areaCode: '',
                email: '',
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                discountRate: null,
                fechaPromotions: null,
                responseDiscountRange: null,
                containDiscountRange: false,
                changeTitlePromotions: false,
                sendDataDiscount: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/Integro-Max' },
                    { text: 'Datos Personales', path: '/Integro-Max/' },
                ],
                referente: null,
                medium: null,
                pas: null,
            }
        },

        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            async pageCustomization() {
                const defaultTitle = 'Íntegro Max';
                const actualPath = '/Integro-Max';
                const actualStep = 'tab-one';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            comenzar() {
                const contactInfoRef = this.$refs.contactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { email, telephone, areaCode, validTelephone, validEmail } = contactInfoRef;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                this.validLastName = this.lastName != '';
                const validateEmail = validEmail;
                const validateLocality = Boolean(this.selectedLocality);


                sessionStorage.removeItem("productId");
                sessionStorage.setItem("productId", "711");

                if (this.validLastName && this.validatePhone && validateEmail && validateLocality) {
                    NF.UI.Page.block();
                    return new Promise<any>(async (resolve) => {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 711, false, "1", null, this.lastName, null).then((response) => {
                            var dataTomador = {
                                name: "",
                                lastName: this.lastName,
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email,
                                selectedLocality: this.selectedLocality,
                                hasDiscount: this.containDiscountRange,
                                discount: this.responseDiscountRange,
                            }
                            resolve(true);
                            sessionStorage.setItem("LeadId", JSON.stringify(response));
                            sessionStorage.removeItem("TabOneWelcome");
                            sessionStorage.setItem("TabOneWelcome", JSON.stringify(dataTomador));

                            this.$router.push({
                                name: 'integro-max-tab-two',
                            })
                        });
                    })
                } else {
                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'apintegro',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-apintegro-view',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);
                }
            },
            RedirectToHome() {
                let urlParams = new URLSearchParams(window.location.search);
                let parameter = urlParams.get('test');
                if (parameter == null) {
                    window.location.href = "https://www.sancorseguros.com.ar/";
                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAPIntegroGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },

        async mounted() {
            NF.UI.Page.block();

            await this.pageCustomization();

            this.updateByProductGoogleAnalytics();

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            const eventData = {
                'pas': this.pas,
                'email': null,
                'product': 'apintegro',
                'event': 'cotizador-apintegro-view',
                'referente': this.referente,
                'medio': this.medium
            };

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push(eventData);

            const customWindow = window as typeof window & {
                _qsie?: Array<typeof eventData>;
            };

            customWindow._qsie ??= [];
            customWindow._qsie.push(eventData);

            new Promise<any>(async (resolve) => {
                DiscountRangeService.getIntegroMaxDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        this.discountRate = this.responseDiscountRange[0].discountMaxValue;
                        this.fechaPromotions = new Date();
                        const FechaInicioEvento = new Date("2024-05-16");
                        const FechaFinEvento = new Date("2024-05-19");
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                    }
                    this.sendDataDiscount = {
                        discountRate: this.discountRate,
                        containDiscountRange: this.containDiscountRange,
                        changeTitlePromotions: this.changeTitlePromotions,
                    };
                });
                NF.UI.Page.unblock();
                this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                resolve(true);
            });
            sessionStorage.clear();
            sessionStorage.setItem("Referente", this.referente);
            sessionStorage.setItem("Medium", this.medium);
        }
    })
